import { useEffect, useRef, useState } from "react";
import throttle from "lodash.throttle";

const useGetRect = () => {
  const [x, setX] = useState();
  const [y, setY] = useState();
  const [width, setWidth] = useState();
  const [height, setHeight] = useState();

  const elemRef = useRef();

  useEffect(() => {
    if (!!elemRef.current) {
      const getPosition = throttle(() => {
        if (elemRef.current) {
          const rect = elemRef.current.getBoundingClientRect();
          //const style = getComputedStyle(elemRef.current);
          setX(rect.left);
          setY(rect.top);
          setWidth(rect.width);
          setHeight(rect.height);
        }
      }, 100);
      window.addEventListener("resize", getPosition);
      window.addEventListener("scroll", getPosition);
      getPosition();
      return () => {
        window.removeEventListener("resize", getPosition);
        window.removeEventListener("scroll", getPosition);
      };
    }
  }, []);

  return { elemRef, x, y, width, height };
};

export default useGetRect;
